import $i18n from 'panda-i18n';
import React, { useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Select,
  Form,
  Field,
  Table,
  Card,
  Pagination,
  Message,
  Input,
  Divider,
  DatePicker,
  ResponsiveGrid,
  Checkbox,
  Grid,
  Icon,
  Box,
  Dialog,
} from '@fpxfd/next';
import PageHeader from '@/components/PageHeader';

import styles from './index.module.scss';
import { useFusionTable, useSetState } from 'ahooks';
import { STOCK_QUALITY } from '@/const';
import { getSkuInfoNotify, putaWayNotify, outPickNotify } from './index.service';
import { Discharge } from './index.interface';

const { Cell } = ResponsiveGrid;

const { Row, Col } = Grid;

const FormItem = Form.Item;
const { RangePicker } = DatePicker;

const FpxDemos = (props) => {
  const [state, setState] = useSetState<Discharge>({
    textlist: [], // 文字列表
    showonku: false,
    showoutku: false,
  });

  const field = Field.useField([]);

  // 选择设备
  const SELECT_SHEBEI = [
    {
      label: $i18n.get({ id: 'Rookie.four_px', dm: '菜鸟' }),
      value: 'CN',
    },

    {
      label: $i18n.get({ id: 'FastWarehouse.four_px', dm: '快仓' }),
      value: 'KC',
    },
  ];

  // 入库单类型下拉框
  const ONKULIST = [
    {
      label: $i18n.get({ id: 'StorageAndShelving.four_px', dm: '入库上架' }),
      value: 'ReceivePutaway',
    },

    {
      label: '移库上架',
      value: 'MovePutaway',
    },
  ];

  // 出库单类型下拉框
  const OUTKULIST = [
    {
      label: $i18n.get({ id: 'OffShelf.four_px', dm: '出库下架' }),
      value: 'PickDown',
    },

    {
      label: $i18n.get({ id: 'RemoveStorageFromShelf.four_px', dm: '移库下架' }),
      value: 'MoveDown',
    },
  ];

  // 商品下发
  const propuctSub = () => {
    const newdatas = JSON.parse(JSON.stringify(field.getValues()));
    const form = {
      agvType: newdatas.agvType,
      data: [
        {
          skuId: newdatas.skuId,
          createUser: 's16204',
          skuName: 'iphone max',
          customerCode: '4PX',
          batchEnabled: 0,
          barcodes: newdatas.skuId.split(' '),
        },
      ],
    };

    getSkuInfoNotify(form).then(() => {
      Message.success($i18n.get({ id: 'OperationSuccessful.four_px', dm: '操作成功' }));
    });
  };

  // 点击入库或者出库下拉框
  const checkSelect = (val, type) => {
    if (type === 1) {
      setState({ showoutku: true });
    } else {
      setState({ showonku: true });
    }
  };

  // 生成随机数
  const randomNums = (max, min) => {
    for (let i = 0; i < 10; i++) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
  };

  // 入库单下发
  const onsetCode = () => {
    const newdatas = JSON.parse(JSON.stringify(field.getValues()));
    const form = {
      agvType: newdatas.agvType,
      data: {
        warehouseCode: 'USLaxa03',
        customerCode: '4PX',
        consignmentNo: `ic${randomNums(10000, 90000)}${1}`,
        createUser: 's16204',
        agvNo: `agv${new Date().getTime()}${1}`,
        containerNo: `BC${randomNums(10000, 99999)}${2}`,
        jobNo: `${randomNums(1000000, 9999999)}${3}`,
        jobType: newdatas.jobType,
        createTime: new Date().getTime(),
        details: [
          {
            skuId: newdatas.skuId,
            agvDetailNo: `${new Date().getTime()}${4}`,
            planQty: newdatas.planQty,
          },
        ],
      },
    };

    putaWayNotify(form).then((res) => {
      Message.success($i18n.get({ id: 'OperationSuccessful.four_px', dm: '操作成功' }));
    });
  };

  // 出库单下发
  const onOutbtns = () => {
    const newdatas = JSON.parse(JSON.stringify(field.getValues()));
    const form = {
      agvType: newdatas.agvType,
      data: {
        warehouseCode: 'USLaxa03',
        agvNos: [
          {
            agvOrderType: newdatas.jobType,
            isMerge: 'Y',
            customerCode: '4PX',
            channelCode: 'HANK',
            agvNo: `agv${randomNums(10000, 9999)}${5}`,
            jobType: newdatas.jobType,
            consignmentNo: `ic${randomNums(10000, 90000)}${1}`,
            needSorting: 'Y',
            createTime: new Date().getTime(),
            expectedOutboundTime: new Date().getTime() + 18000,
            details: [
              {
                customerCode: '4PX',
                skuId: newdatas.skuId,
                agvDetailNo: `agv${randomNums(10000000, 9000000)}${6}`,
                planQty: newdatas.planQty,
                consignmentNo: `ic${randomNums(10000, 90000)}${1}`,
              },
            ],
          },
        ],
      },
    };

    outPickNotify(form).then((res) => {
      Message.success($i18n.get({ id: 'OperationSuccessful.four_px', dm: '操作成功' }));
    });
  };

  // 文字列表
  return (
    <div className={styles.wrapper}>
      <h3 className={styles.h4title}>
        {$i18n.get({
          id: '4pxOverseasWarehouseAgvLaboratoryJoint_2235413600.four_px',
          dm: '4PX-海外仓AGV实验室联调系统',
        })}
      </h3>
      <Form fullWidth field={field}>
        <Row align="top" wrap gutter="24">
          <Col span="12">
            <FormItem label={$i18n.get({ id: 'DeviceSelection.four_px', dm: '设备选择' })}>
              <Select name="agvType" dataSource={SELECT_SHEBEI} />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="SKU ID">
              <Input placeholder="输入SKU ID" aria-label="Large" name="skuId" />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label={$i18n.get({ id: 'InboundOrderType.four_px', dm: '入库订单类型' })}>
              <Select
                name="jobType"
                disabled={state.showonku}
                dataSource={ONKULIST}
                onChange={(val) => {
                  checkSelect(val, 1);
                }}
              />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label={$i18n.get({ id: 'Number.four_px', dm: '数量' })}>
              <Input
                placeholder={$i18n.get({ id: 'InputQuantity.four_px', dm: '输入数量' })}
                aria-label="Large"
                name="planQty"
              />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label={$i18n.get({ id: 'OutboundOrderType.four_px', dm: '出库单类型' })}>
              <Select
                name="jobType"
                disabled={state.showoutku}
                dataSource={OUTKULIST}
                onChange={(val) => {
                  checkSelect(val, 2);
                }}
              />
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div className={styles.Buttons}>
        <Button
          type="primary"
          onClick={() => {
            propuctSub();
          }}
        >
          {$i18n.get({ id: 'ProductDelivery.four_px', dm: '商品下发' })}
        </Button>
        <Button
          type="primary"
          onClick={() => {
            onsetCode();
          }}
        >
          {$i18n.get({ id: 'IssueReceipt.four_px', dm: '入库单下发' })}
        </Button>
        <Button
          type="primary"
          onClick={() => {
            onOutbtns();
          }}
        >
          {$i18n.get({ id: 'IssueTheDeliveryOrder.four_px', dm: '出库单下发' })}
        </Button>
      </div>
      <div className={styles.maplist}>
        {state.textlist!.map((value, index) => {
          return <p key={index}>{value.text}</p>;
        })}
      </div>
    </div>
  );
};

export default FpxDemos;
